import { View } from "react-native";
import { Switch } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import InfoText from "./InfoText";

type Props = {
  enabled: boolean;
  title: string;
  details: string;
  onChange: (value: boolean) => void;
  loading?: boolean;
};

export default function SwitchWithText({
  enabled,
  onChange,
  title,
  details,
  loading,
}: Props) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-row")}>
      <InfoText title={title} details={details} style={tailwind("flex-1")} />

      <Switch
        value={enabled}
        onValueChange={onChange}
        style={tailwind("self-center")}
        disabled={loading}
      />
    </View>
  );
}
